const emptyCellCode = "-";

export default emptyCellCode;